import { Icon } from "@iconify/react";

const Rating = ({ rating }) => {
  const MAX_STARS = 5;
  const fullStars = Math.floor(rating);
  const hasHalfStar = rating % 1 !== 0;
  const emptyStars = MAX_STARS - fullStars - (hasHalfStar ? 1 : 0);
  return (
    <div className="flex items-center">
      {Array.from({ length: fullStars }, (_, index) => (
        <Icon icon="iconamoon:star-fill" key={`star-${index}`} className="w-4 h-4 mr-1" color="#FFBF03" />
      ))}
      {hasHalfStar && <Icon icon="tabler:star-half-filled" className="w-4 h-4  mr-1" color="#FFBF03" />}
      {Array.from({ length: emptyStars }, (_, index) => (
        <Icon icon="iconamoon:star-light" key={`empty-star-${index}`} className="w-4 h-4 mr-1" color="#FFBF03" />
      ))}
    </div>
  );
};

export default Rating;
